import { Injectable, signal } from '@angular/core';

export interface ConfirmDialogOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'default' | 'danger';
}

export interface PromptDialogOptions {
  title: string;
  message?: string;
  label?: string;
  placeholder?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  allowEmpty?: boolean;
  maxLength?: number;
  /** Texto con el que abre el campo (p. ej. para corregir un valor existente). */
  initialValue?: string;
}

@Injectable({ providedIn: 'root' })
export class DialogService {
  private readonly confirmState = signal<ConfirmDialogOptions | null>(null);
  private readonly promptState = signal<PromptDialogOptions | null>(null);
  private pendingConfirm: ((result: boolean) => void) | null = null;
  private pendingPrompt: ((value: string | null) => void) | null = null;

  readonly confirmRequest = this.confirmState.asReadonly();
  readonly promptRequest = this.promptState.asReadonly();

  confirm(options: ConfirmDialogOptions): Promise<boolean> {
    this.resolveConfirm(false);
    this.confirmState.set(options);
    return new Promise<boolean>((resolve) => {
      this.pendingConfirm = resolve;
    });
  }

  prompt(options: PromptDialogOptions): Promise<string | null> {
    this.resolvePrompt(null);
    this.promptState.set(options);
    return new Promise<string | null>((resolve) => {
      this.pendingPrompt = resolve;
    });
  }

  resolveConfirm(result: boolean): void {
    const resolve = this.pendingConfirm;
    this.pendingConfirm = null;
    this.confirmState.set(null);
    resolve?.(result);
  }

  resolvePrompt(value: string | null): void {
    const resolve = this.pendingPrompt;
    this.pendingPrompt = null;
    this.promptState.set(null);
    resolve?.(value);
  }
}
